var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widget-report" }, [
    _c("div", { staticClass: "row no-gutters card-header text-white" }, [
      _c("div", { staticClass: "col-5 d-inline-block widget-title" }, [
        _vm._v("\n      " + _vm._s(_vm.widgetInfo.widgetTitle) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-7 d-inline-block text-right smaller-font-content" },
        [
          _c("div", { staticClass: "row justify-content-end" }, [
            _vm.productFilters && _vm.hasOptions(_vm.productFilters)
              ? _c(
                  "div",
                  { staticClass: "tabs d-flex mx-2 p-filter" },
                  [
                    _c("filter-products", {
                      staticClass: "d-block w-auto",
                      attrs: {
                        widgetType: "select",
                        fieldData: _vm.productFilters
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.chartDateFiltersPrimary &&
            _vm.hasOptions(_vm.chartDateFiltersPrimary)
              ? _c(
                  "div",
                  { staticClass: "tabs d-flex mx-2" },
                  [
                    _c("filter-daterange", {
                      staticClass: "d-block w-auto",
                      attrs: {
                        widgetType: "select",
                        fieldData: _vm.chartDateFiltersPrimary
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.widgetInfo.route
            ? _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "align-middle text-white",
                      attrs: { to: { name: _vm.widgetInfo.route } }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.widgetInfo.linkTitle))]),
                      _c("i", { staticClass: "fas fa-angle-right ml-1" })
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ]),
    _vm._v(" "),
    _vm.widgetType === "report" || _vm.widgetType === "list"
      ? _c(
          "div",
          {
            staticClass: "data-table",
            staticStyle: {
              "-webkit-transform": "none",
              transform: "none",
              perspective: "none",
              filter: "none"
            }
          },
          [
            _c("datatable-block", {
              attrs: {
                dataFilters: _vm.dataFilters,
                persistentDimension: null,
                tableData: _vm.reportDataPrimary,
                tableDataSecondary: _vm.reportDataSecondary,
                chartFiltersFilters: {},
                dimensionProperty: _vm.dimensionProperty,
                widgetType: _vm.widgetType,
                isLoading: _vm.isLoading
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.widgetType === "chart"
      ? _c("div", { staticClass: "data-chart" }, [
          _c("canvas", {
            ref: "report-card-002",
            attrs: { id: "report-card-002", width: "80%", height: "70" }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "widget-loader" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLoading,
              expression: "isLoading"
            }
          ],
          staticClass: "loader-content text-center"
        },
        [
          _c("i", { staticClass: "fas fa-circle-o-notch fa-spin mr-1" }),
          _vm._v("Loading…\n    ")
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0f9cddc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0f9cddc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/widgets/ReportWidget.vue
// module id = null
// module chunks = 